import { firestore } from "../../firebase/util";

const collectionName = "business-details";

/**
 * handleAddDetails
 */
export const handleAddDetails = (details) => {

  return new Promise((resolve, reject) => {
    firestore
      .collection(collectionName)
      .doc()
      .set(details)
      .then(() => {
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * handleEditDetails
 */
export const handleEditDetails = (details) => {

  return new Promise((resolve, reject) => {
    firestore
      .collection(collectionName)
      .doc(details.documentID)
      .update(details)
      .then(() => {
        resolve();
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
};

/**
 * handleFetchDetails2
 */export const handleFetchDetails = (request, persistDetails = []) => {


  return new Promise((resolve, reject) => {
    let ref = firestore
      .collection(collectionName)
      .where("userUID", '==', request.uid)
      .limit(1);

    ref
      .get()
      .then((snapshot) => {
        const totalCount = snapshot.size;
        const data = [
          ...persistDetails,
          ...snapshot.docs.map((doc) => {
            return {
              ...doc.data(),
              documentID: doc.id,
            };
          }),
        ];

        resolve({
          data,
          queryDoc: snapshot.docs[totalCount - 1],
          isLastPage: totalCount < 1,
        });
      })
      .catch((err) => {
        reject(err);
      });

    
  });
};

/**
 * handleDeleteProduct
 */
export const handleDeleteDetails = (userUID) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection(collectionName)
      .doc((userUID) => userUID)
      .delete()
      .then(() => {
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * handleFetchDetails
 */
 export const handleFetchDetails2 = (uid) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection(collectionName)
      .where("userUID",'==', uid)
      .doc()
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          resolve({
            ...snapshot.data()
          });
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
